import { createContext, useContext, useState } from 'react';

const CommonFeaturesContext = createContext();

export const CommonFeaturesProvider = ({ children }) => {
  const [isChatBotOpen, setIsChatBotOpen] = useState(false);

  const toggleChatBot = () => setIsChatBotOpen(prev => !prev);

  const value = {
    chatBot: {
      isOpen: isChatBotOpen,
      toggle: toggleChatBot,
      setOpen: setIsChatBotOpen,
    },
  };

  return <CommonFeaturesContext.Provider value={value}>{children}</CommonFeaturesContext.Provider>;
};

export const useCommonFeatures = () => useContext(CommonFeaturesContext);
